import React, { useState } from 'react'

import PrintSetup from './PrintSetup'

import Tabs, { type TabOption } from '@/components/common/Tabs'

const tabOptions: TabOption[] = [
  {
    label: '打印机',
    value: 'printer'
  }
]

interface SettingTabsProps {
  children?: React.ReactNode
}
const SettingTabs: React.FC<SettingTabsProps> = () => {
  const [activeTab, setActiveTab] = useState<TabOption>(tabOptions[0])

  return (
    <>
      <Tabs
        activeValue={activeTab.value}
        options={tabOptions}
        onChange={(value) => {
          const foundOption = tabOptions.find(
            (option) => option.value === value
          )
          if (foundOption) {
            setActiveTab(foundOption)
          }
        }}
      />

      {activeTab.value === 'printer' && <PrintSetup />}
    </>
  )
}

export default SettingTabs
